// extracted by mini-css-extract-plugin
export var container = "_cd-0";
export var segment = "_cd-2";
export var segmentActive = "_cd-3";
export var track = "_cd-1";